/* eslint-disable */
;(function ($) {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	var initializeBlock = function ($block) {
		$block.addClass('umc-health-calculators-block')
		$block.umcHealthCalculators()
	}

	// Initialize each block on page load (front end).
	jQuery(document).ready(function () {
		$('.umc-health-calculators').each(function () {
			$(this).umcHealthCalculators()
		})
	})

	$.umcHealthCalculators = function (el, options) {
		// To avoid scope issues, use 'base' instead of 'this'
		// to reference this class from internal events and functions.
		var base = this

		base.$el = $(el)
		base.el = el

		base.$el.data('umcHealthCalculators', base)

		base.className = '.umc-health-calculators'
		base.okBmi = '1'
		base.okBmiMetric = '1'
		base.okBmr = '1'
		base.okBmrMetric = '1'
		base.okBodyfatFemale = '1'
		base.okBodyfatMale = '1'
		base.okBodyfatMetricMale = '1'
		base.okBodyfatMetricFemale = '1'
		base.okWaistHip = '1'
		base.okWaistHipMetric = '1'

		base.init = function () {
			if (!$(base.className + '__tab-container ul', base.$el).attr('data-responsive-accordion-tabs')) {
				$(base.className + '__tab_content', base.$el).hide()
				$('ul[data-umc-tabs] li:first', base.$el).addClass('active').show()
				$(base.className + '__tab_content:first', base.$el).show()
			}

			$('ul[data-umc-tabs] li a', base.$el).click(function () {
				if (!$(this).parents('ul').attr('data-responsive-accordion-tabs')) {
					$('ul[data-umc-tabs] li', base.$el).removeClass('active')
					$(this).parent('li').addClass('active')
					$(base.className + '__tab_content', base.$el).hide()
					var activeTab = $(this).data('tabTarget')

					$(base.className + '__tab_content[data-tab-content=' + activeTab + ']', base.$el).fadeIn()
					return false
				}
			})
			base.el.querySelector('section' + base.className + '__tab-container').style.display = ''

			$('.button', base.$el).click(function (evnt) {
				evnt.preventDefault()
				var that = this
				var parents = $(this).parents(base.className + '__tab_content')
				if (0 < parents.length) {
					var calculator = $(parents[0]).data('tabContent')
					switch (calculator) {
						case 'bmi':
							base._bmiCalculate(that)
							break
						case 'bmr':
							base._bmrCalculate(that)
							break
						case 'body-fat':
							base._bodyfatCalculate(that)
							break
					}
				}
			})

			$('input[name=bodyfatGender]', base.$el).change(function () {
				var parentElements = $(this).parents(base.className + '__tab_content')
				var parent = null
				if (0 < parentElements.length) parent = $(parentElements[0])

				$('.body_fat_field_female', base.$el).toggle()
				$(base.className + '__error-msg', parent).hide()
			})
		}

		base._bmiCalculate = function (trigger) {
			var bmiresult
			var bminormallow
			var bminormalhigh
			var bmistatus
			var parentElements = $(trigger).parents(base.className + '__tab_content')
			var parent = null
			if (0 < parentElements.length) parent = $(parentElements[0])

			if (null === parent) return false

			// bmiFeet = document.bmiForm.bmiFeet.value;
			bmiFeet = $('.bmi_height_feet', base.$el).val()
			bmiInches = $('.bmi_height_inches', base.$el).val()
			bmiWeight = $('.bmi_weight', base.$el).val()

			if (
				isNaN(bmiFeet) ||
				isNaN(bmiInches) ||
				isNaN(bmiWeight) ||
				bmiFeet == '' ||
				bmiInches == '' ||
				bmiWeight == ''
			) {
				$(base.className + '__error-msg', parent).show('slow')
				$(base.className + '__bmi-result', parent).html('')
				$(base.className + '__bmi-status', parent).html('')
				$(base.className + '__bmi-range', parent).html('')
			} else {
				$(base.className + '__error-msg', parent).hide('slow')

				bmiFeet = parseInt(bmiFeet)
				bmiInches = parseInt(bmiInches)
				bmiWeight = parseInt(bmiWeight)

				bmiinchresult = bmiFeet * 12 + bmiInches
				bmiinchresult = bmiinchresult * bmiinchresult
				bmiresult = (bmiWeight * 703) / bmiinchresult
				bmiresult = Math.round(bmiresult * 100) / 100
				if (bmiresult < 18.5) bmistatus = 'Underweight'
				if (bmiresult >= 18.5 && bmiresult <= 24.99) bmistatus = 'Normal'
				if (bmiresult >= 25 && bmiresult <= 29.99) bmistatus = 'Overweight'
				if (bmiresult > 30) bmistatus = 'Obese'
				bminormallow = Math.ceil((18.5 * bmiinchresult) / 703)
				bminormalhigh = Math.floor((24.99 * bmiinchresult) / 703)
				$(base.className + '__bmi-result', parent).html(bmiresult)
				$(base.className + '__bmi-status', parent).html(bmistatus)
				$(base.className + '__bmi-range', parent).html(bminormallow + ' - ' + bminormalhigh + ' lbs')
			}
			return false
		}

		base._bmrCalculate = function (trigger) {
			var bmrresult
			var parentElements = $(trigger).parents(base.className + '__tab_content')
			var parent = null
			if (0 < parentElements.length) parent = $(parentElements[0])

			if (null === parent) return false

			bmrFeet = $('.bmr_height_feet', parent).val()
			bmrInches = $('.bmr_height_inches', parent).val()
			bmrWeight = $('.bmr_weight', parent).val()
			bmrAge = $('.bmr_age', parent).val()
			bmrGender = $('input[name=bmrGender]:checked', parent).val()
			resultElement = $(base.className + '__bmr-result', parent)
			errorElement = $(base.className + '__error-msg', parent)

			if (
				isNaN(bmrFeet) ||
				isNaN(bmrInches) ||
				isNaN(bmrWeight) ||
				isNaN(bmrAge) ||
				bmrFeet == '' ||
				bmrInches == '' ||
				bmrWeight == '' ||
				bmrAge == ''
			) {
				$(errorElement).show('slow')
				$(resultElement).html('')
			} else {
				$(errorElement).hide('slow')

				bmrAge = parseInt(bmrAge)
				bmrFeet = parseInt(bmrFeet)
				bmrInches = parseInt(bmrInches)
				bmrWeight = parseInt(bmrWeight)
				bmiinchresult = bmrFeet * 12 + bmrInches

				if ('female' === bmrGender) {
					bmrresult = 655 + 4.35 * bmrWeight + 4.7 * bmiinchresult - 4.7 * bmrAge
					console.log((bmrresult = 655 + 4.35 * bmrWeight + 4.7 * bmiinchresult - 4.7 * bmrAge))
				} else {
					bmrresult = 66 + 6.23 * bmrWeight + 12.7 * bmiinchresult - 6.8 * bmrAge
					console.log((bmrresult = 66 + 6.23 * bmrWeight + 12.7 * bmiinchresult - 6.8 * bmrAge))
				}
				bmrresult = Math.round(bmrresult)
				$(resultElement).html(bmrresult)
			}
			return false
		}

		base._bodyfatCalculate = function (trigger) {
			var bodyfatResult
			var gender = null
			var parentElements = $(trigger).parents(base.className + '__tab_content')
			var parent = null
			if (0 < parentElements.length) parent = $(parentElements[0])

			if (null === parent) return false

			gender = $('input[name=bodyfatGender]:checked', parent).val()
			bodyfatWeight = $('.body_fat_weight', parent).val()
			bodyfatWaist = $('.body_fat_waist', parent).val()
			bodyfatWrist = $('.body_fat_wrist', parent).val()
			bodyfatHips = $('.body_fat_hips', parent).val()
			bodyfatForearm = $('.body_fat_forearm', parent).val()
			resultElement = $(base.className + '__body-fat-result', parent)
			errorElement = $(base.className + '__error-msg', parent)
			if ('female' === gender) {
				if (
					isNaN(bodyfatWeight) ||
					isNaN(bodyfatWaist) ||
					isNaN(bodyfatWrist) ||
					isNaN(bodyfatHips) ||
					isNaN(bodyfatForearm) ||
					bodyfatWeight == '' ||
					bodyfatWaist == '' ||
					bodyfatWrist == '' ||
					bodyfatHips == '' ||
					bodyfatForearm == ''
				) {
					$(errorElement).show('slow')
					$(resultElement).html('')
				} else {
					$(errorElement).hide('slow')
					base.okBodyfatFemale = '1'
					bodyfatWeight = parseFloat(bodyfatWeight)
					bodyfatWrist = parseFloat(bodyfatWrist)
					bodyfatWaist = parseFloat(bodyfatWaist)
					bodyfatHips = parseFloat(bodyfatHips)
					bodyfatForearm = parseFloat(bodyfatForearm)
					factor1 = bodyfatWeight * 0.732 + 8.987
					factor2 = bodyfatWrist / 3.14
					factor3 = bodyfatWaist * 0.157
					factor4 = bodyfatHips * 0.249
					factor5 = bodyfatForearm * 0.434
					leanbodymass = factor1 + factor2 - factor3 - factor4 + factor5
					bodyfatweight = bodyfatWeight - leanbodymass
					bodyfatResult = (bodyfatweight * 100) / bodyfatWeight
					bodyfatResult = Math.round(bodyfatResult * 100) / 100
					$(resultElement).html(bodyfatResult + '%')
				}
			} else {
				if (isNaN(bodyfatWeight) || isNaN(bodyfatWaist) || bodyfatWeight == '' || bodyfatWaist == '') {
					$(errorElement).show('slow')
					$(resultElement).html('')
				}
				//calculation Male
				else {
					$(errorElement).hide('slow')

					bodyfatWeight = parseFloat(bodyfatWeight)
					bodyfatWaist = parseFloat(bodyfatWaist)
					factor1 = bodyfatWeight * 1.082 + 94.42
					factor2 = bodyfatWaist * 4.15
					leanbodymass = factor1 - factor2
					bodyfatweight = bodyfatWeight - leanbodymass
					bodyfatResult = (bodyfatweight * 100) / bodyfatWeight
					bodyfatResult = Math.round(bodyfatResult * 100) / 100
					$(resultElement).html(bodyfatResult + '%')
				}
			}
			return false
		}

		// Run initializer
		base.init()
	}

	$.fn.umcHealthCalculators = function (options) {
		return this.each(function () {
			new $.umcHealthCalculators(this, options)
		})
	}

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=umc-health-calculators-block', initializeBlock)
	}
})(jQuery)
